/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import { goToHomeHybridMod } from '@/navigation/CSR/goToHomeHybridMod'
import { getSimpleViewOptions } from '@/useCases/simpleViewOptions'
import { useLocale } from '@mercadoni/mimic/dist/cjs/locale/contexts/LocaleContext'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import { Header as MainHeader } from '@mercadoni/sinister/dist/cjs/header'
import { usePathname, useRouter } from 'next/navigation'
import styled from 'styled-components'

const HeaderStyled = styled.div`
  position: sticky;
  top: 0px;
  z-index: var(--z-index-9);
  box-shadow: var(--shadow-boxShadow);
  .header__main > .ant-dropdown {
    .ant-btn {
      display: flex;
      justify-content: flex-start;
    }
  }
`

const SimpleHeader = () => {
  const { header, theme } = UseClientModelContext()
  const { simpleHeader: copy } = useLocale()
  const router = useRouter()
  const { desktop } = theme?.header || {}
  const { isLightBackground } = desktop || {}

  const onClickLogo = async () => await goToHomeHybridMod(router)
  const pathname = usePathname()
  const simpleViewOptions = getSimpleViewOptions({
    copy,
    router,
    pathname,
  })

  return (
    <HeaderStyled id="header-container" className="header-container">
      <MainHeader
        {...header}
        isSimple={true}
        simpleViewOptions={simpleViewOptions}
        isLightBackground={isLightBackground}
        onClickLogo={onClickLogo}
      />
    </HeaderStyled>
  )
}

export default SimpleHeader
